<div class="dialog">
  <div class="animated-circle-icon huge green">
    <app-svg src="/assets/icons/flag-check.svg"></app-svg>
  </div>

  <h1>Approvals Completed</h1>
  <p>{{ gallery.approval_limits | abs }} of {{ gallery.approval_limits | abs }} assets are approved.</p>

  <button
    appButton
    name="confirm"
    location="approval-done-dialog"
    color="primary"
    shape="round"
    height="4"
    size="3"
    spacing="full"
    (click)="close()"
  >
    Ok
  </button>
</div>
